module.exports = __webpack_public_path__ + "media/images/alert_sign-d80f3513274c8def5f3f34ccd11575a7.svg";